import gsap from 'gsap';

export const initPublicationsList = () => {
    document.querySelectorAll('.c-publications')?.forEach(publications => {
        const list = publications.querySelector('.c-publications-list');
        const button = publications.querySelector('.c-button');

        if (publications.classList.contains('backend') || !list || !button) return;

        const visibleCount = 5; // Amount of publications visible at once or to be added to be visible.
        const listDuration = visibleCount * 0.25; // Duration of the list animation.

        let count = list.childElementCount;
        let visiblePublications = 0; // Current visible publications.

        // Set initial list height to 0.
        gsap.set(list, { height: 0 });

        const setVisiblePublications = () => {
            const initial = visiblePublications === 0;

            visiblePublications += visibleCount;
            if (visiblePublications > count) visiblePublications = count;

            let delay = 0;

            list.childNodes.forEach((publication, index) => {
                publication.classList.toggle('hidden', index >= visiblePublications);

                // Animate publication visibility and list height.
                if (!publication.classList.contains('hidden') && !publication.classList.contains('animated')) {
                    gsap.set(publication, { autoAlpha: 0, x: '-3rem' });
                    gsap.to(publication, {
                        delay: initial ? 0 : delay * 0.25,
                        duration: initial ? 0 : 1,
                        autoAlpha: 1,
                        x: 0,
                    });
                    gsap.to(list, { duration: initial ? 0 : listDuration, height: 'auto' });
                    publication.classList.add('animated');
                }

                delay += 1;

                // Reset delay if it is equal to the visible publications count.
                if (delay === visibleCount) delay = 0;
            });

            // Set the list height to its current height after the animation to make animation to "height: auto" possible.
            setTimeout(
                () => list.style.setProperty('height', list.offsetHeight + 'px'),
                initial ? 0 : listDuration * 1000
            );

            if (visiblePublications === count) {
                // Button fade out animation.
                gsap.to(button.parentNode, {
                    duration: listDuration,
                    marginTop: 0,
                    height: 0,
                    paddingTop: 0,
                    paddingBottom: 0,
                    y: '3rem',
                    display: 'none',
                });
                gsap.to(button, { duration: listDuration, height: 0, y: '3rem', display: 'none' });
                gsap.to(button, { duration: 0, autoAlpha: 0 });
            } else {
                button.parentNode.classList.remove('hidden');
            }
        };

        setVisiblePublications();

        button.addEventListener('click', setVisiblePublications);
    });
};

/**
 * Fix the publications list height on window resize.
 */
export const fixPublicationsListHeightOnResize = () => {
    document.querySelectorAll('.c-publications')?.forEach(publications => {
        const list = publications.querySelector('.c-publications-list');

        if (!list) return;

        let height = 0;

        // Get the height from list publication heights.
        list.childNodes.forEach(publication => (height += publication.offsetHeight));
        list.style.setProperty('height', height + 'px');
    });
};
